import { useMemo } from 'react';
import { useWorldStore } from '../state/worldStore';

// WHERE EACH VENUE IS RIGHT NOW, unsaved edits included.
//
// `venueAnchors` is what CityModel derived: the sampler, a rooms.js `anchorMesh`
// pin, or a SAVED hand placement. It deliberately does not know about drafts,
// because folding them in there would mean re-running the effect that measures
// every candidate building in the city on each click of the placement tool.
//
// But a draft that only the ghost can see is why the tool felt inert: you drop
// the outline, and the marker and the footprint stay where they were, so the
// venue reads as refusing to move. Nothing tells you the click registered.
//
// So the draft is merged HERE, downstream and cheaply, and everything that draws
// a venue reads through this — the marker, the plan-view footprint, and the room
// itself. Drop it and the whole thing moves at once; the only difference between
// draft and saved is whether it survives a reload.
export function useVenueAnchors() {
  const anchors = useWorldStore((s) => s.venueAnchors);
  const drafts = useWorldStore((s) => s.venuePlaceDraft);
  return useMemo(() => {
    if (!anchors) return null;
    const ids = Object.keys(drafts || {});
    if (!ids.length) return anchors;
    const out = { ...anchors };
    for (const id of ids) {
      const d = drafts[id];
      // A draft carrying only a scale has no position to apply — leave the
      // venue where it is rather than yanking it to the origin.
      if (!d || d.x == null || !out[id]) continue;
      out[id] = [d.x, out[id][1], d.z];
    }
    return out;
  }, [anchors, drafts]);
}
